/**
 * Email domains not allowed for new signups (disposable / burner / high-risk).
 * Use lowercase hostnames only (the part after @).
 * Keep in sync with backend/src/constants/blockedSignupEmailDomains.ts
 */
export const BLOCKED_SIGNUP_EMAIL_DOMAINS: readonly string[] = [
  "sharebot.net",
  // Add more domains as needed (lowercase)
];

function normalizeEmailDomain(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf("@");
  if (at < 0 || at === trimmed.length - 1) return null;
  return trimmed.slice(at + 1);
}

/** Returns true if the email's domain is blocked for signup. */
export function isSignupEmailDomainBlocked(email: string): boolean {
  const domain = normalizeEmailDomain(email);
  if (!domain) return false;
  return BLOCKED_SIGNUP_EMAIL_DOMAINS.includes(domain);
}
